import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../reducers/rootReducer';
import {
  PREFERRED_UNIT,
  ALARM_ID_DECIMAL,
  ALARM_ID_HEXADECIMAL,
} from '../../constants';
import './UserDialog.scss';
import {
  setUserPreference,
  setAlarmIdRepresentation,
  userSessionSelectors,
} from '../../../reducers/userSessionSlice';
import DialogComponent from '../../../components/Dialog/DialogComponent';
import UserDialogContent from './UserDialogContent';
import {
  translationSelectors,
  updateLanguage,
} from '../../../reducers/translationSlice';
import { setStoredRepresentation } from '../../../components/App/hooks/useAlarmIdRepresentation';

function UserDialog({ open, setOpen }) {
  const dispatch = useDispatch();

  const alarmIdRepresentation = useAppSelector(
    userSessionSelectors.selectAlarmIdRepresentation,
  );
  const { accessToken, currentUser: username } = useAppSelector(
    (state) => state.userSession,
  );
  const preferredLanguage = useAppSelector(
    translationSelectors.selectPreferredLanguages,
  );

  const [unit, setUnit] = useState<string>('');
  const [language, setLanguage] = useState(preferredLanguage);
  const [representation, setRepresentation] = useState<
    typeof ALARM_ID_DECIMAL | typeof ALARM_ID_HEXADECIMAL
  >(alarmIdRepresentation);

  useEffect(() => {
    setRepresentation(alarmIdRepresentation);
  }, [alarmIdRepresentation]);

  useEffect(() => {
    setLanguage(preferredLanguage);
  }, [preferredLanguage]);

  const onSave = () => {
    dispatch(updateLanguage({ accessToken, language }));
    dispatch(setUserPreference(unit));
    dispatch(setAlarmIdRepresentation(representation));
    setStoredRepresentation(username, representation);
    localStorage.setObject(PREFERRED_UNIT, unit);
    setOpen(false);
  };
  const onClose = () => {
    setLanguage(preferredLanguage);
    setOpen(false);
  };

  return (
    <DialogComponent
      title="User settings"
      content={
        <UserDialogContent
          language={language}
          setLanguage={setLanguage}
          unit={unit}
          setUnit={setUnit}
          alarmIdRepresentation={representation}
          setAlarmRepresentation={setRepresentation}
        />
      }
      rightButton="Save"
      rightAction={onSave}
      leftButton="Cancel"
      leftActionProp={onClose}
      className="user-settings"
      setOpen={setOpen}
      open={open}
      disabledButton={false}
    />
  );
}

export default UserDialog;
